
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","viewBox":"0 0 14 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.75 13A1.75 1.75 0 010 11.25v-2.5a.75.75 0 011.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 00.25-.25v-2.5a.75.75 0 111.5 0v2.5A1.75 1.75 0 0112.25 13H1.75zm4.5-6.56V.75a.75.75 0 111.5 0v5.69l1.97-1.97a.749.749 0 111.06 1.06L7.53 8.78a.75.75 0 01-1.06 0L3.22 5.53a.749.749 0 111.06-1.06l1.97 1.97z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    